import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { UniqueMechanismSection } from './components/UniqueMechanismSection';
import { CTASection } from './components/CTASection';
import { TransformationSection } from './components/TransformationSection';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
import { StickyBottomBar } from './components/StickyBottomBar';
import { initPixel } from './utils/pixel';
export function App() {
  useEffect(() => {
    document.title = 'Rescate Clave de Paz | Salva tu relación';
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute('content', 'Descubre el método práctico para reconstruir la comunicación, sanar heridas y blindar tu pareja contra las crisis financieras y el agotamiento mental.');
    } else {
      const newMeta = document.createElement('meta');
      newMeta.name = 'description';
      newMeta.content = 'Descubre el método práctico para reconstruir la comunicación, sanar heridas y blindar tu pareja contra las crisis financieras y el agotamiento mental.';
      document.head.appendChild(newMeta);
    }
    initPixel();
  }, []);
  return <div className="w-full min-h-screen bg-[#FAF7F2] text-[#2C2C2C] font-sans" data-id="element-0">
      {/* Urgency Banner */}
      <div className="w-full bg-[#1B4B5A] text-white py-3 px-4 text-center font-sans" data-id="element-1">
        <p className="text-sm md:text-base font-semibold tracking-wide" data-id="element-2">
          ⏳ Oferta especial: <span className="text-[#E5A83B]" data-id="element-3">69% OFF</span>{' '}
          solo por hoy. Precio normal{' '}
          <span className="line-through opacity-70" data-id="element-4">$15.900</span> → Hoy{' '}
          <span className="text-[#4fc251] font-bold" data-id="element-5">$4.929</span>
        </p>
      </div>
      <HeroSection data-id="element-6" />
      <ProblemSection data-id="element-7" />
      <UniqueMechanismSection data-id="element-8" />
      <CTASection data-id="element-9" />
      <TransformationSection data-id="element-10" />
      <FAQSection data-id="element-11" />
      <Footer data-id="element-12" />
      <StickyBottomBar data-id="element-13" />
    </div>;
}